import RecentDevicesView from "./RecentDevicesView";
export default RecentDevicesView;